module.exports = __webpack_public_path__ + "img/signup-email1.f3220730.png";